import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-deposit-default-amounts',
  templateUrl: './deposit-default-amounts.component.html',
  styleUrls: ['./deposit-default-amounts.component.scss'],
})
export class DepositDefaultAmountsComponent implements OnInit {
  @Input() defaultAmounts: any;
  @Input() minAmount: any;
  @Input() title: any;

  @Output() defaultAmountSelected = new EventEmitter<number>();

  constructor(){
  }

  ngOnInit(){

  }

  selectAmount(value: number){
    this.defaultAmountSelected.emit(value);
  }

}
